let config = null;

if ( process.env.NODE_ENV === "production" && process.env.REACT_APP_ENV === "production") 
  config = {
    apiUrl: "https://api.20pesewas.com/prime.sika/v1",
    ws: "wss://api.20pesewas.com/websocket",
    heroku: "https://prime-admin-backend.herokuapp.com/prime.sika/v1",
    apiUrl_open: "https://api.20pesewas.com/acc.egift.card/v1",
  };
else
  config = {
    apiUrl: "https://api.primeegiftcard.com/prime.sika/v1",
    // apiUrl: "https://3866-154-160-10-50.ngrok.io/prime.sika/v1",
    ws: "wss://api.primeegiftcard.com/websocket",
    heroku: "https://prime-admin-backend.herokuapp.com/prime.sika/v1",
    apiUrl_open: "https://api.primeegiftcard.com/acc.egift.card/v1",
  };

export { config };

